export const DEFAULT_LOCALE = 'en-US' as const;

export const SUPPORTED_LOCALES = ['en-US', 'vi-VN'] as const;

export type AppLocale = (typeof SUPPORTED_LOCALES)[number];
export type UserLangKey = 'en' | 'vi';

export function normalizeAppLocale(locale?: string | null): AppLocale {
  if (locale === 'vi-VN') {
    return 'vi-VN';
  }
  return DEFAULT_LOCALE;
}

export function toAppLocaleFromLangKey(langKey?: string | null): AppLocale {
  if (langKey === 'vi') {
    return 'vi-VN';
  }
  return DEFAULT_LOCALE;
}

export function toLangKeyFromLocale(locale?: string | null): UserLangKey {
  return normalizeAppLocale(locale) === 'vi-VN' ? 'vi' : 'en';
}

export function isVietnameseLocale(locale?: string | null): boolean {
  return normalizeAppLocale(locale) === 'vi-VN';
}
